var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLpAfiS3Line(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 119,
    viewBox: "0 0 12 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.77344 10L11.5469 2.52368e-07L-6.53267e-05 -2.52368e-07L4.77344 10L6.77344 10ZM4.77343 109L-7.05283e-05 119L11.5469 119L6.77343 109L4.77343 109ZM5.77344 22.3125L4.77344 22.3125L4.77344 37.1875L5.77344 37.1875L6.77344 37.1875L6.77344 22.3125L5.77344 22.3125ZM5.77344 52.0625L4.77344 52.0625L4.77343 66.9375L5.77343 66.9375L6.77343 66.9375L6.77344 52.0625L5.77344 52.0625ZM5.77343 81.8125L4.77343 81.8125L4.77343 96.6875L5.77343 96.6875L6.77343 96.6875L6.77343 81.8125L5.77343 81.8125Z",
    fill: "#FFE500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpAfiS3Line);
export default __webpack_public_path__ + "static/media/lp_afi_s3_line.ebf27171d06fdef51463e36a92b5e26a.svg";
export { ForwardRef as ReactComponent };